module.exports = __webpack_public_path__ + "img/icon-equals.96aed6c3.svg";